import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      height: 'auto',
      maxHeight: '200px',
      transition: 'all 0.25s ease-out',
      '@media (max-width: 1024px)': {
        maxHeight: '600px'
      }
    },
    podium: {
      display: 'flex',
      gap: '20px',
      justifyContent: 'space-between',
      height: '200px',
      marginBottom: '50px',
      '@media (max-width: 1024px)': {
        flexDirection: 'column',
        height: '550px',
        marginBottom: '90px',
        '&>:nth-child(1)': {
          order: 2
        },
        '&>:nth-child(2)': {
          order: 1
        },
        '&>:nth-child(3)': {
          order: 3
        }
      }
    },
    ranking: {
      '@media (max-width: 1024px)': {
        width: 'calc(100% + 30px)',
        transform: 'translateX(-15px)'
      }
    },
    open: {
      height: 'auto',
      maxHeight: 'max-content'
    },
    more: {
      position: 'absolute',
      bottom: '4px',
      '@media (max-width: 1024px)': {
        bottom: '6px'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
